"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OwnerDetailsFormDisplaySettingsPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formFieldPropTypes = require("./formFieldPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable react/forbid-prop-types */

const OwnerDetailsFormDisplaySettingsPropTypes = exports.OwnerDetailsFormDisplaySettingsPropTypes = {
  heading: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element, _propTypes.default.func]),
  headingReadonly: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element, _propTypes.default.func]),
  accordionBehaviour: _propTypes.default.bool,
  showMembershipField: _propTypes.default.bool,
  showPromoCodeField: _propTypes.default.bool,
  showName: _propTypes.default.bool,
  showBirthdate: _propTypes.default.bool,
  showPostCode: _propTypes.default.bool,
  ownerBirthdateInput: _propTypes.default.shape(_formFieldPropTypes.InheritedFormFieldPropTypes),
  ownerEmailInput: _propTypes.default.shape(_formFieldPropTypes.InheritedFormFieldPropTypes),
  ownerNameInput: _propTypes.default.shape(_formFieldPropTypes.InheritedFormFieldPropTypes),
  ownerPostCodeInput: _propTypes.default.shape(_formFieldPropTypes.InheritedFormFieldPropTypes),
  ownerMembershipRadios: _propTypes.default.shape(_formFieldPropTypes.InheritedRadioPropTypes),
  ownerPromoCodeInput: _propTypes.default.shape(_formFieldPropTypes.InheritedFormFieldPropTypes)
};